import CarriersList from './carriers-list';

export default CarriersList;
